import styled from "styled-components";

const StyledSvg = styled.svg`
  height: 1em;
  padding-right: 0.2em;
  padding-left: 0.2em;
  cursor: pointer;
  color: var(--color-field-point-0);
  :hover {
    color: var(--color-field-point-0-alt);
  }
`;

interface BinIconProps {
  handleOnRemovePlayer: () => void;
}

const BinIcon = ({ handleOnRemovePlayer }: BinIconProps) => {
  return (
    <span onClick={handleOnRemovePlayer}>
      <StyledSvg
        stroke="var(--color-field-point-0)"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 -3 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path fill="none" d="M0 0h24v24H0z"></path>
          <path d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm-8 5v6h2v-6H9zm4 0v6h2v-6h-2zM9 4v2h6V4H9z"></path>
        </g>
      </StyledSvg>
    </span>
  );
};
export default BinIcon;
